module.exports = __webpack_public_path__ + "static/image-2-7a2bd93c6421880b97f2d7bed8face48.jpg";